export default function BasketService() {
    var service = {
        combinedBookings: [], // JS ALTERATION - UNITED COHEREN BOOKINGS -> TSendt this to server RESERVE BOOKINGS FINAL
    };

    return service;
}
